
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bootcamps/[id]",
      function () {
        return require("private-next-pages/bootcamps/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bootcamps/[id]"])
      });
    }
  